import Vue from "vue";
import swal from "sweetalert2";
Vue.prototype.$alert = swal;
